/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-02 15:30:42
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-22 17:48:38
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelMultiLanguageSelect/MultilLanguageHoc.tsx
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetPageLanguageList } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useSelector } from 'react-redux';
import { currentSalesChannelUuid } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useGetPageStyleList } from 'src/constrains/SalesChannelStyleSelect/hooks';
import { currentSalesChannelUuid as styleSalesChannelUuid } from 'src/constrains/SalesChannelStyleSelect/slice';
import { useSalesChannelIsMiniProgram } from 'src/constrains/SalesChannelHOC/useSalesChannel';
const useSalesChannel = (params) => {
  const {
    type,
    saleChannelUuidKey = 'uuid',
    reduxAccessKeys,
    noListener: noLanguageListener,
    isStyleRequired,
  } = params;
  const isMini = useSalesChannelIsMiniProgram();
  const p: any = useParams();
  const salesChannelUuid = p[saleChannelUuidKey];

  useGetPageLanguageList({
    type,
    saleChannelUuid: salesChannelUuid,
    reduxAccessKeys: reduxAccessKeys || [type],
    noListener: noLanguageListener,
  });
  useGetPageStyleList({
    type,
    saleChannelUuid: salesChannelUuid,
    reduxAccessKeys: reduxAccessKeys || [type],
    isStyleRequired: !isMini && isStyleRequired,
  });

  const uuidInRedux = useSelector(currentSalesChannelUuid());
  const uuidInStyleRedux = useSelector(styleSalesChannelUuid());
  //console.log('uuidInStyleRedux', uuidInStyleRedux);
  const isCurrent = isStyleRequired
    ? uuidInRedux === p[saleChannelUuidKey] &&
      uuidInStyleRedux === p[saleChannelUuidKey]
    : uuidInRedux === p[saleChannelUuidKey];
  return { isCurrent };
};

const SalesChannelHOC = (Component, params) => {
  const {
    type,
    saleChannelUuidKey = 'uuid',
    reduxAccessKeys,
    noListener: noLanguageListener,
    isStyleRequired,
  } = params;

  const WrappedComponent = (props) => {
    const p: any = useParams();
    const salesChannelUuid = p[saleChannelUuidKey];

    useGetPageLanguageList({
      type,
      saleChannelUuid: salesChannelUuid,
      reduxAccessKeys: reduxAccessKeys || [type],
      noListener: noLanguageListener,
    });
    useGetPageStyleList({
      type,
      saleChannelUuid: salesChannelUuid,
      reduxAccessKeys: reduxAccessKeys || [type],
      isStyleRequired,
    });

    const uuidInRedux = useSelector(currentSalesChannelUuid());
    const uuidInStyleRedux = useSelector(styleSalesChannelUuid());
    //console.log('uuidInStyleRedux', uuidInStyleRedux);
    const isCurrent = isStyleRequired
      ? uuidInRedux === p[saleChannelUuidKey] &&
        uuidInStyleRedux === p[saleChannelUuidKey]
      : uuidInRedux === p[saleChannelUuidKey]; //不同salesChannel不显示
    // console.log('isCurrent', isCurrent);
    return <Component {...props} __isCurrentSalesChannel={isCurrent} />;
  };
  return WrappedComponent;
};
export default SalesChannelHOC;

export const _SelectHOC = (Component) => {
  const _Component = (props) => {
    // console.log('__isCurrentSalesChannel', props.__isCurrentSalesChannel);
    const { __isCurrentSalesChannel, ...rest } = props;
    const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());
    return __isCurrentSalesChannel ? (
      <Component {...rest} isPrimary={isOnPrimaryLanguage} />
    ) : null;
  };
  return _Component;
};
export { _SelectHOC as SelectHOC, useSalesChannel };
